export const WRAP_PROPS = {
  value: { // 面板数据。支持双向绑定
    type: Array,
    default: () => ([])
  },
  layoutModel: { // 布局的模式
    type: String,
    default: 'single' // single（单行：超过一行 放到更多里面/或者左右滑动） flat（平铺，换行展示）
  },
  label: {
    type: String,
    default: '更多'
  },
  height: {
    type: Number,
    default: 30
  },
  showCheckbox: Boolean,
  cellWrapClassName: String,
  draggedId: String, // 拖拽 存入本地缓存的ID
  selectMode: String, // 单选的模式 none 无 single 单选
  morePopoverAttrs: {
    type: Object,
    default: () => ({})
  },
  customMoreOption: [Function, Object],
  draggedPriorityElevation: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/props/wrap.js